// Depois de um deploy, o browser pode tentar carregar um chunk JS (rota
// lazy via react-loadable) cujo hash não existe mais no servidor. O fallback
// SPA da Vercel devolve index.html (200) no lugar do JS, e o browser tenta
// parsear esse HTML como script — o que estoura um SyntaxError global
// "Unexpected token '<'" que não é capturável via try/catch (é erro de parse
// de <script>, não uma rejeição de promise do import()).
//
// Quando o chunk volta como 404 ou o download falha na rede, não há
// SyntaxError: o import() rejeita com o ChunkLoadError do webpack, que chega
// ao AsyncLoader como `error` e é tratado lá com reloadStaleChunk.
//
// Como o usuário já está numa versão desatualizada, a correção é recarregar
// a página para buscar o novo index.html com os hashes corretos.

const RELOAD_STORAGE_KEY = 'stale-chunk-reload-at'
const RELOAD_COOLDOWN = 60 * 1000

const isStaleChunkError = message =>
  typeof message === 'string' && message.includes("Unexpected token '<'")

// ChunkLoadError cobre chunks JS; chunks CSS falham com um Error comum e a
// mensagem "Loading CSS chunk ... failed".
export const isChunkLoadError = error =>
  error?.name === 'ChunkLoadError' ||
  /Loading (CSS )?chunk .* failed/.test(error?.message || '')

const canReload = () => {
  const lastReload = Number(sessionStorage.getItem(RELOAD_STORAGE_KEY) || 0)
  return Date.now() - lastReload > RELOAD_COOLDOWN
}

// Recarrega no máximo uma vez por RELOAD_COOLDOWN, para não entrar em loop
// se o chunk continuar indisponível. Retorna se o reload foi disparado.
export const reloadStaleChunk = () => {
  if (!canReload()) return false

  sessionStorage.setItem(RELOAD_STORAGE_KEY, String(Date.now()))
  window.location.reload()
  return true
}

export const setupStaleChunkReload = () => {
  window.addEventListener('error', event => {
    if (!isStaleChunkError(event?.message)) return

    reloadStaleChunk()
  })
}
